import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, fmtMoney } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import DealCard from "@/components/DealCard";
import { toast } from "sonner";

export default function CategoryDetail() {
  const { slug } = useParams();
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");

  useEffect(() => {
    api.get(`/catalog/offers?category=${slug}&limit=40`).then((r) => setItems(r.data)).catch(() => {});
    api.get("/catalog/categories").then((r) => {
      const cat = r.data.find((c) => c.slug === slug);
      setName(cat?.name || slug);
    });
  }, [slug]);

  const handleShop = async (offer) => {
    try {
      await api.post("/wallet/click", { offer_id: offer.id });
      await api.post("/wallet/simulate-purchase", { offer_id: offer.id, order_amount: 100 });
      toast.success(`Cashback approved: ${fmtMoney((100 * (offer.cashback_rate || 5)) / 200)}`);
    } catch (e) {
      toast.error("Couldn't track click");
    }
  };

  return (
    <div data-testid="page-category-detail">
      <PageHeader eyebrow="Category" title={name} subtitle={`${items.length} live offers`} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((o) => (
          <DealCard key={o.id} offer={o} onShop={handleShop} />
        ))}
      </div>
    </div>
  );
}
